import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

@Component({
    selector: 'app-vis-map',
    templateUrl: './vis-map.component.html'
})
export class VisMapComponent implements OnChanges {
    @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
    @Input() mapData;

    centerMarker;
    markersContainer;
    markers;
    polylines;
    polylineOptions = {
        icons: [
            {
                icon: {
                    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                },
                offset: "100%"
            }
        ],
        strokeColor: '#32a1d0',
        strokeOpacity: 1.0,
        strokeWeight: 2
    };
    infoContent;
    
    openInfo(marker: MapMarker, eventData) {
        this.infoContent = eventData;
        this.info.open(marker);
    }

    ngOnChanges(): void {
        // console.log(this.mapData);
        this.markersContainer = this.mapData.markerData;
        this.polylines = this.mapData.polylineData;
        this.markers = [...this.markersContainer.values()];
        let [firstKey] = this.markersContainer.keys();
        this.centerMarker = {
            lat: parseFloat(firstKey.split(',')[0]),
            lng: parseFloat(firstKey.split(',')[1])
        }
    }
}